import { useState, useContext } from "react";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import { UserDataContext } from "../components/UserDataContext";
import { registerLocale } from "react-datepicker";
import { addDays, isAfter } from "date-fns";
import { format } from "date-fns";
import "../components/button.css";
import { TextField, FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { pl } from "date-fns/locale";
import { marginBottom } from "../App";
import Alerts from "../components/Alerts";
import Button from "@mui/material/Button";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { apiRequest } from "../components/Config";

const validationSchema = Yup.object().shape({
  user: Yup.string().required("Użytkownik jest wymagany"),
  fullName: Yup.string().required("Imię i nazwisko są wymagane"),
  city: Yup.string().required("Miejscowość jest wymagana"),
  email: Yup.string()
    .email("Nieprawidłowy adres email")
    .required("Email jest wymagany"),
  selectedDate: Yup.date()
    .nullable()
    .required("Data jest wymagana")
    .test(
      "is-after-today",
      "Data musi być późniejsza niż dzisiaj",
      (value) => value && isAfter(value, new Date())
    ),
});

export default function AddUser({ refreshData }) {
  registerLocale("pl", pl);

  const { userData } = useContext(UserDataContext);
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  const initialValues = {
    user: "",
    fullName: "",
    city: "",
    email: "",
    phone: "",
    selectedDate: new Date(new Date().getFullYear(), 11, 31),
    expire: "",
    permId: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const formatted = format(values.selectedDate, "yyyy-MM-dd");
    values["idgrp"] = userData.idGrp;
    values["expire"] = formatted;
    values["permId"] = 1;
    console.log("do zapisu: ", values);

    try {
      const response = await apiRequest("register", "POST", values);

      if (response.error_msg === 200) {
        setShowApiResponse(true);
        setApiResponse({
          title: "Sukces",
          severity: "success",
          info: "Użytkownik dodany!",
        });
        refreshData();
      }
      if (response.error_msg === 500) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Coś poszło nie tak podczas rejestracji. Prawdopodobnie nie zostały wybrane uprawnienia użytkownika. Spróbuj ponownie lub skontaktuj się z autorem.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Takie konto już istnieje w systemie!",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <h4>Rejestracja konta Administratora</h4>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <ThemeProvider theme={theme}>
            <FormikForm>
              <Row style={{ marginBottom }} className="align-items-center">
                <Col md="4">
                  <FormControl fullWidth>
                    <Field name="user">
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          label="Konto logowania"
                          variant="standard"
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </FormControl>
                </Col>
                <Col md="4">
                  <FormControl fullWidth>
                    <Field name="fullName">
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          label="Nazwisko i Imię Administratora"
                          variant="standard"
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </FormControl>
                </Col>
                <Col md="4">
                  <FormControl fullWidth>
                    <Field name="city">
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          label="Miasto zamieszkania"
                          variant="standard"
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </FormControl>
                </Col>
              </Row>
              <Row style={{ marginBottom }} className="align-items-center">
                <Col md="2" style={{ marginBottom }}>
                  <FormControl fullWidth>
                    <Field name="email">
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          label="Email"
                          variant="standard"
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </FormControl>
                </Col>
                <Col md="2" style={{ marginBottom }}>
                  <FormControl fullWidth>
                    <Field name="phone">
                      {({ field, meta }) => (
                        <TextField
                          {...field}
                          label="Telefon"
                          variant="standard"
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                        />
                      )}
                    </Field>
                  </FormControl>
                </Col>
                <Col md="2" style={{ marginBottom }}>
                  <FormControl fullWidth>
                    <Field name="selectedDate">
                      {({ field, form, meta }) => (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={pl}
                        >
                          <DatePicker
                            label="Wybierz datę ważności konta"
                            value={field.value ? new Date(field.value) : null}
                            onChange={(newValue) => {
                              form.setFieldValue(
                                field.name,
                                newValue
                                  ? newValue.toISOString().slice(0, 10)
                                  : ""
                              );
                              //ClearApiResponse();
                            }}
                            minDate={addDays(new Date(), 1)}
                            format="yyyy-MM-dd"
                            slotProps={{
                              textField: {
                                variant: "standard",
                                error: meta.touched && Boolean(meta.error),
                                helperText: meta.touched && meta.error,
                                fullWidth: true,
                              },
                            }}
                          />
                        </LocalizationProvider>
                      )}
                    </Field>
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Rejestruj
                  </Button>
                </Col>
              </Row>

              <hr></hr>
            </FormikForm>
          </ThemeProvider>
        )}
      </Formik>
    </div>
  );
}
